export default "__VITE_ASSET__BKRgC8Lm__"